import { escapeRegExp } from "@helpers/escapeRegExp";

export interface TextPart {
    text: string;
    isMatch: boolean;
}

/** The trimmed search query from a global filter value of any shape. */
export const toSearchQuery = <TFilter>(filter: TFilter): string =>
    typeof filter === "string" ? filter.trim() : "";

/**
 * The query when `text` contains it (case-insensitive), else "". Cells select
 * this from the global filter, so a cell without a match keeps returning ""
 * and does not re-render while the user types.
 */
export const getMatchingQuery = <TFilter>(
    text: string,
    filter: TFilter,
): string => {
    const query = toSearchQuery(filter);
    if (query === "") {
        return "";
    }
    return text.toLowerCase().includes(query.toLowerCase()) ? query : "";
};

/** Splits `text` into alternating plain and matching parts, case-insensitive. */
export const splitMatches = (text: string, query: string): TextPart[] => {
    if (query === "") {
        return [{ text, isMatch: false }];
    }
    const pattern = new RegExp(`(${escapeRegExp(query)})`, "gi");
    // A capturing split alternates plain and matched parts: odd indexes match.
    return text
        .split(pattern)
        .map((part, index) => ({ text: part, isMatch: index % 2 === 1 }))
        .filter((part) => part.text !== "");
};
